<template>
  <div
    ref="screenshotTarget"
    style="padding: 32px 15px"
    class="starter-main mycontainer body-mobile-gen"
  >
    <!-- <HeaderPage :title="header.title" :list="header.list" :image="header.image" :tipe_gambar="header.tipe" /> -->

    <div class="row profit-sidebar">
      <div class="col-12">
        <GenerationMap
          :last_update="last_update.generation_map"
          :data="generation_map"
        ></GenerationMap>
      </div>
      <div class="col-12">
        <GenerationCapacity
          :last_update="last_update.generation_capacity"
        ></GenerationCapacity>
      </div>
      <div class="col-12">
        <FuelMix :last_update="last_update.fuel_mix"></FuelMix>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import moment from "moment";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";

import HeaderPage from "@/components/HeaderPage.vue";
import GenerationMap from "./cards/GenerationMap.vue";
import GenerationCapacity from "./cards/GenerationCapacity.vue";
import FuelMix from "./cards/FuelMix.vue";

export default {
  components: {
    HeaderPage,
    GenerationMap,
    GenerationCapacity,
    FuelMix,
  },
  data() {
    return {
      //notification bar
      header: {
        title:
          "Today's system-wide generation is at 32.87% cadangan nationally",
        list: [
          "Attention required for Sistem Interkoneksi Kalimantan (1.32%), Sistem Bau Bau (18.23%), Sistem JaMaLi ( 20.67%), and Sistem Sumatera (28.23%)",
          "System disruption in Interkoneksi Kalimantan is due to flood and heavy rain.",
        ],
        image: require("@/assets/images/logo/image_kanan2.png"),
        tipe: "color-burn",
      },

      last_update: {
        generation_map: "1 Month Ago",
        generation_capacity: "2 Weeks Ago",
        fuel_mix: "2 Hours Ago",
      },

      generation_map: {
        electricity_generated_value: "68,253",
        electricity_generated_change: "3.2%",
        electricity_generated_trend: "4.6%",
        availability_factor_value: "100%",
        availability_factor_change: "3.2%",
        availability_factor_trend: "4.6%",
        equivalent_availability_factor_value: "86.34%",
        equivalent_availability_factor_change: "3.2%",
        equivalent_availability_factor_trend: "4.6%",
        scheduled_outage_factor_value: "91.41%",
        scheduled_outage_factor_change: "3.2%",
        scheduled_outage_factor_trend: "4.6%",
        equivalent_force_outage_rate_value: "4.12%",
        equivalent_force_outage_rate_change: "3.2%",
        equivalent_force_outage_rate_trend: "4.6%",
        power_reserve_value: "32.87%",
        power_reserve_change: "3.2%",
        power_reserve_trend: "4.6%",

        installed_power_value: "72,876",
        installed_power_change: "3.2%",
        installed_power_trend: "4.6%",
        bpp_for_generation_value: "1,432",
        bpp_for_generation_change: "3.2%",
        bpp_for_generation_trend: "4.6%",
        net_plant_heat_rate_value: "3,401",
        net_plant_heat_rate_change: "3.2%",
        net_plant_heat_rate_trend: "4.6%",
        operation_days_value: "28",
        operation_days_change: "3.2%",
        operation_days_trend: "4.6%",
        sfc_coal_value: "0.611",
        sfc_coal_change: "3.2%",
        sfc_coal_trend: "4.6%",
        sfc_oil_value: "0.038",
        sfc_oil_change: "3.2%",
        sfc_oil_trend: "4.6%",
        sfc_gas_value: "0.0085",
        sfc_gas_change: "3.2%",
        sfc_gas_trend: "4.6%",
      },
    };
  },
  created() {
    this.$store.commit("updateJudulHalaman", "");
  },
  computed: {
    ...mapGetters(["shouldTriggerFunction5"]),
  },
  watch: {
    shouldTriggerFunction5(newVal) {
      if (newVal) {
        this.takeScreenshot(); // Call your function here
        this.$store.dispatch("resetTriggerFunction5"); // Reset trigger after calling function
      }
    },
  },
  methods: {
    async takeScreenshot() {
      const targetElement = this.$refs.screenshotTarget;

      try {
        const canvas = await html2canvas(targetElement);
        this.downloadCanvasImage(canvas);
      } catch (error) {
        console.error("Error while taking screenshot:", error);
      }
    },
    downloadCanvasImage(canvas) {
      // Convert canvas to image data URL
      const imgData = canvas.toDataURL("image/png");

      // Create temporary link element
      const downloadLink = document.createElement("a");
      downloadLink.href = imgData;
      downloadLink.download = `Generation_${moment(new Date()).format("DD-MM-YYYY HH:mm")}.png`;
      document.body.appendChild(downloadLink);

      // Trigger download
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
    cumulative() {
      this.isActiveCumulative = !this.isActiveCumulative;
    },
    toggleSwitch() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style scoped></style>
